import styled from "styled-components";

import { BreadcrumbItem as BreadcrumbItemDefault } from "reactstrap";

export const BreadcrumbItem = styled(BreadcrumbItemDefault)`
  font-size: 12px;
`;
